import { ColorTokens, BottomTabStateToken, } from '@voltmoney/schema';
export const bottomTabStateMap = {
    [BottomTabStateToken.SELECTED]: {
        labelColor: ColorTokens.Primary_100,
        bgColor: ColorTokens.White,
    },
    [BottomTabStateToken.NOT_SELECTED]: {
        labelColor: ColorTokens.Grey_Charcoal,
        bgColor: ColorTokens.White,
    },
};
